import React from "react";
import "./ImageSetter.scss"

export function ImageSetter(props: {
    url: string | null,
    onSet: (file: File) => void
}) {


    function onDrop(evt: React.DragEvent) {
        evt.preventDefault();
        const file = getFirstFile(evt);
        if (!file)
            return;
        props.onSet(file);
    }

    function onDragOver(evt: React.DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.dataTransfer.dropEffect = "copy";
    }
    const classes = [
        "image-setter",
        props.url ? "img-set" : "img-unset"
    ];

    const style: React.CSSProperties = {
        backgroundImage: props.url ? `url(${props.url})` : undefined
    };

    return (
        <div className={classes.join(" ")}
            onDrop={onDrop}
            onDragOver={onDragOver}
            style={style}
            
        >
            <span>Drag image here</span>
        </div>
        );
}
function getFirstFile(evt: React.DragEvent) {
    if (!evt.dataTransfer.items)
        return;
    for (let i = 0; i < evt.dataTransfer.items.length; i++) {
        let item = evt.dataTransfer.items[i];
        if (item.kind === "file") {
            return item.getAsFile();
        }
    }
    return;
}
